import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface PollQuestionResult {
  questionId: string;
  text: string;
  type: string;
  options?: string[];
  optionCounts?: number[];
  textAnswers?: string[];
  totalResponses: number;
}

interface PollResultsData {
  pollId: string;
  title: string;
  totalResponses: number;
  questions: PollQuestionResult[];
}

interface UsePollResultsReturn {
  results: PollResultsData | null;
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function usePollResults(pollId: string | undefined): UsePollResultsReturn {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: queryKeys.polls.results(pollId!),
    queryFn: () => api.getPollResults(pollId!),
    enabled: !!pollId,
  });

  return {
    results: data ?? null,
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load results' : null,
    refresh: () => {
      refetch();
    },
  };
}
